export default "__VITE_ASSET__b69f7f15__"